"use strict";

require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.define-property");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var miniNotifications = {
  init: function init() {
    this.root = $("#miniNoti");
    this.removeAllButton = $("#miniNotiRemoveAll");
    this.removeAllButton.click(function () {
      miniNotifications.removeAll();
    });
    return this;
  },
  defaults: {
    lifespan: 5000
  },
  root: null,
  removeAllButton: null,
  removeAll: function removeAll() {
    this.root.find(".noti").each(function () {
      miniNotifications.remove($(this));
    });
  },
  remove: function remove(note) {
    note.animate({
      opacity: 0,
      marginLeft: -50
    }, 200, "linear").animate({
      height: 0
    }, 100, function () {
      note.remove();
      miniNotifications.toggleRemoveAllButton();
    });
  },
  toggleRemoveAllButton: function toggleRemoveAllButton() {
    var _this = this;
    if (this.root.find(".noti").length >= 2) {
      this.removeAllButton.show().animate({
        height: 50
      }, 100).animate({
        opacity: 1,
        marginLeft: 0
      }, 200);
    } else {
      this.removeAllButton.animate({
        opacity: 0,
        marginLeft: -50
      }, 200).animate({
        height: 0
      }, 100, function () {
        return _this.removeAllButton.hide();
      });
    }
  },
  add: function add(msg, type, config, extraClass) {
    var _this = this;
    if (type === void 0) {
      type = "info";
    }
    if (config === void 0) {
      config = {};
    }
    if (extraClass === void 0) {
      extraClass = null;
    }
    if (_typeof(type) === "object") {
      config = type;
      type = config.type || "info";
    }
    config = Object.assign({}, this.defaults, config);
    var notifications = $("<span class='noti noti-" + type + " " + extraClass + "'>" + msg + "<i class='fa fa-times noti-close'></i></span>");
    notifications.css({
      opacity: 0,
      marginLeft: -50
    }).animate({
      opacity: 1,
      marginLeft: 0
    }, 200).on('click', $('.noti-close').parent(), function () {
      return _this.remove(notifications);
    });
    this.root.append(notifications);
    this.toggleRemoveAllButton();
    setTimeout(function () {
      return _this.remove(notifications);
    }, config.lifespan);
  }
};
var Notifications = miniNotifications.init();
exports.Notifications = Notifications;